module.exports = __webpack_public_path__ + "img/lg_ring_g_l_0_0.912a978c.png";